



















































































import Vue from 'vue'
import actions from '@/actions'
import store from '@/store'

export default Vue.extend({
  name: 'Services',

  data: () => ({
    portfolioImage: { id: '', name: '', src: '' },
    store,
  }),

  methods: {
    inhome(e: Event) {
      e.preventDefault()
      this.store.clearSignup()
      this.store.setSignupType('inhome', 'In-Home Consultation')
      this.$router.push({ name: 'SignupCustomer' })
    },
    goToPortfolio() {
      this.$router.push({ name: 'PortfolioDetail', params: { id: this.portfolioImage.id } })
    },
    refresh(e: Event) {
      e.preventDefault()
      this.store.clearSignup()
      this.store.setSignupType('refresh', 'Furnishings and Styling Refresh')
      this.$router.push({ name: 'SignupIntro' })
    },
    remodel(e: Event) {
      e.preventDefault()
      this.store.clearSignup()
      this.store.setSignupType('remodel', 'Remodel Consulting')
      this.$router.push({ name: 'SignupIntro' })
    },
  },

  async mounted() {
    const { id, name, image } = await actions.getRandomPortfolioPhoto()
    this.portfolioImage = {
      id,
      name,
      src: `${store.state.apiBaseUrl}/img/portfolio/${id}/${image.remoteFilename}`,
    }
  },
})
